import { Outlet } from 'react-router';

import { OverlayHost, UrlOverlayHost } from '@shared/ui/overlay';
import { ToastHost } from '@shared/ui/toast';

/**
 * 모든 라우트의 바깥 틀. 전역 UI 인프라를 **마운트만** 한다.
 * store 와 호출 API 는 `shared/ui/overlay` · `shared/ui/toast` 에 있다
 * (아래 레이어가 app 을 import 하지 않게).
 */
export function RootLayout() {
  return (
    <>
      <Outlet />
      <UrlOverlayHost />
      <OverlayHost />
      <ToastHost />
    </>
  );
}
